module.exports = __webpack_public_path__ + "static/media/picturetopeople.org-16f868893a3190c91745104caf3707e364f84637a247df396c.47ef6c34.png";